var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBaby = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.1 32.6c-.3-1.1-.6-5.6-.6-7.4 0-3.2 1-4.4 1-7 0-6.6-4.7-9.7-10.5-9.7S9.5 11.6 9.5 18.2c0 2.6 1 2.5 1 7 0 2.2-.2 6.5-.5 7.4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.1 10.6a7.1 7.1 0 1 1 0 14.2 7.1 7.1 0 0 1 0-14.2Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.6 23.9S20.6 26 20 27"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9 23.4c.1.1 6.1 4.4 8.7 9.2M23 16c.718 0 1.3.627 1.3 1.4s-.582 1.4-1.3 1.4-1.3-.627-1.3-1.4.582-1.4 1.3-1.4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.4 16.1a.5.5 0 1 1-.001 1.002.5.5 0 0 1 .001-1.002ZM17.2 16c.718 0 1.3.627 1.3 1.4s-.582 1.4-1.3 1.4-1.3-.627-1.3-1.4.582-1.4 1.3-1.4Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.7 16.3a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM19.2 22.1q-.6-.45-.6-1.2c0-.9.7-1.5 1.5-1.5s1.5.7 1.5 1.5q0 .75-.6 1.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.6 20.7.3.6c.2.6.5 1.1.2 1.4q-.15.3-.9.3t-.9-.3c-.2-.3 0-.7.2-1.2.1-.3.2-.5.3-.8M19.9 13.9v-1.4s.1-.7.8-.7c.5 0 .9.1.9.9 0 0 .1.8-1.2.8 0 0-.8 0-1.2-.7-.2-.4-.2-.9.1-1.4 0 0 .4-.6.5-1.2 0-.4-.1-.7-.1-.7"
}))));
export default SvgBaby;